import dotPropImmutable from 'dot-prop-immutable';
import { asTemplateAllocation } from '../utils/as-template-allocation';
export const allocationSlice = {
    bulkActions: (state, { payload: { actionsMap, relativeDate, isHoursPerWeek } })=>{
        const path = `data.${state.activeId}.allocations`;
        let allocations = dotPropImmutable.get(state, path, {});
        const asAllocation = asTemplateAllocation(relativeDate, isHoursPerWeek);
        allocations = Object.values(actionsMap.delete).reduce((result, allocation)=>{
            const { [allocation.id]: deletedAllocation, ...rest } = result;
            return rest;
        }, allocations);
        allocations = Object.values(actionsMap.update).reduce((result, allocation)=>{
            const { [allocation.id]: oldAllocation, ...rest } = result;
            return {
                [allocation.id]: asAllocation(allocation),
                ...rest
            };
        }, allocations);
        allocations = Object.keys(actionsMap.create).reduce((result, id)=>{
            return {
                ...result,
                [id]: asAllocation({
                    id: parseInt(id, 10),
                    ...actionsMap.create[id]
                })
            };
        }, allocations);
        return dotPropImmutable.set(state, path, allocations);
    },
    setAllocatedMembers: (state, { payload: { teams, users } })=>{
        const path = `data.${state.activeId}.allocatedMembers`;
        return dotPropImmutable.set(state, path, {
            users,
            teams
        });
    },
    deleteAllocationsByIds: (state, { payload: { allocationIds } })=>{
        const path = `data.${state.activeId}.allocations`;
        const allocations = dotPropImmutable.get(state, path, {});
        const nextAllocations = allocationIds.reduce((result, allocationId)=>{
            const { [allocationId]: deletedAllocation, ...rest } = result;
            return rest;
        }, allocations);
        return dotPropImmutable.set(state, path, nextAllocations);
    },
    /** Clears task/phase linkage on allocations when template auto-allocate is turned off. */ stripAllocationSources: (state)=>{
        const path = `data.${state.activeId}.allocations`;
        const allocations = dotPropImmutable.get(state, path, {});
        const next = Object.keys(allocations).reduce((acc, key)=>{
            const alloc = allocations[key];
            const sources = alloc === null || alloc === void 0 ? void 0 : alloc.sources;
            if (sources == null || sources.length === 0) {
                return acc;
            }
            const base = acc !== null && acc !== void 0 ? acc : {
                ...allocations
            };
            return {
                ...base,
                [key]: {
                    ...alloc,
                    sources: []
                }
            };
        }, undefined);
        if (next == null) {
            return state;
        }
        return dotPropImmutable.set(state, path, next);
    }
};
